import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal, CardImg, Alert } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { elementClosest, joinSpans } from '@fullcalendar/react';

const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {
	
    sessionStorage.getItem("SchemeRec_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');

   if(sessionStorage.getItem("SchemeRec_Action")=="Add")
   {
	    setSaveButtonText("Save");
      setRecNo("{Auto}");
       
   if (sessionStorage.getItem("NewScheme_SchCode")==="")
    {

    }
    else
    {

     
      setSchCode(sessionStorage.getItem("NewScheme_SchCode"));
      setChitCode(sessionStorage.getItem("NewScheme_ChitCode"));

      getChitList();
      getChitDetail();

    }

      //Clear();
   
   }
   else if(sessionStorage.getItem("SchemeRec_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("SchemeRec_EditId"));
   }
   else if(sessionStorage.getItem("SchemeRec_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("SchemeRec_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  

  function innitialSetValue() {


  getLookup();
  
  }



  const [isDisabled, setisDisabled]=useState(false);
  
  const [dtScheme, setdtScheme]=useState([]);
  const [dtChitList, setdtChitList]=useState([]);


  const [dtChitDet, setdtChitDet,dtChitDetRef]=useStateRef([]);
  const [dtChitPaidDet, setdtChitPaidDet,dtChitPaidDetRef]=useStateRef([]);
  const [dtEmp, setdtEmp,dtEmpRef]=useStateRef([]);
  const [dtCard, setdtCard]=useState([]);
  const [dtChqBank, setdtChqBank]=useState([]);
  const [dtRecMode,setdtRecMode]=useState([]);
  
  const [btndisabled, setDisabled] = useState('disabled');


  const [DtCardDetTable, setDtCardDetTable, DtCardDetTableRef]=useStateRef([]);
  let CardDetTable=[];

  const [DtDetTable, setDtDetTable, DtDetTableRef]=useStateRef([]);
  let DetTable=[];

  

  const [Chequeshow1, setChequeshow1] = useState(false);
  const CheuqehandleClose1 = () => setChequeshow1(false);
  const ChequehandleShow1 = () => setChequeshow1(true);
  
  const [UPIShow1, setUPIhow1] = useState(false);
  const UPIhandleClose1 = () => setUPIhow1(false);
  const UPIhandleShow1 = () => setUPIhow1(true);
  
  const [CashShow1, setCashshow1] = useState(false);
  const CashhandleClose1 = () => setCashshow1(false);
  const CashhandleShow1 = () => setCashshow1(true);
  

  const [Cardshow1, setCardshow1] = useState(false);
  const CardhandleClose1 = () => setCardshow1(false);
  const CardhandleShow1 = () => setCardshow1(true);
  
  
   const [RecNo, setRecNo, RecNoRef] = useStateRef(0);
   const [RecDate, setRecDate, RecDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   const [SchCode, setSchCode, SchCodeRef] = useStateRef(0);
   const [SchName, setSchName, SchNameRef] = useStateRef('');
   const [ChitCode, setChitCode, ChitCodeRef] = useStateRef(0);
   const [RecMode, setRecMode, RecModeRef] = useStateRef('');
   const [ChqBankName,setChqBankName,ChqBankNameRef]=useStateRef('');
   const [ChqNo,setChqNo,ChqNoRef]=useStateRef('');
   const [SchType,setSchType,SchTypeRef]=useStateRef('');
   const [ChqDate,setChqDate,ChqDateRef]= useStateRef((new Date()).toISOString().substring(0,10));
   const [ChqAmount,setChqAmount,ChqAmountRef]=useStateRef(0);
   const [RecAmount,setRecAmount,RecAmountRef]=useStateRef(0);
   const [RecIns,setRecIns,RecInsRef]=useStateRef(1);
   const [CustId,setCustId,CustIdRef]=useStateRef(0);
   const [CustName,setCustName,CustNameRef]=useStateRef('');
   const [Mobile,setMobile,MobileRef]=useStateRef('');
   const [Address1,setAddress1,Address1Ref]=useStateRef('');
   const [Address2,setAddress2,Address2Ref]=useStateRef('');
   const [Address3,setAddress3,Address3Ref]=useStateRef('');
   const [City,setCity,CityRef]=useStateRef('');
   const [PinCode,setPinCode,PinCodeRef]=useStateRef('');
   const [EmailId,setEmailId,EmailIdRef]=useStateRef('');
   const [EmpId1,setEmpId1,EmpId1Ref]=useStateRef('');
   const [EmpName1,setEmpName1,EmpName1Ref]=useStateRef('');
   const [UPIId,setUPIId,UPIIdRef]=useStateRef('');
   const [UPIRefNo,setUPIRefNo,UPIRefNoRef]=useStateRef('');
   const [UPIAmount,setUPIAmount,UPIAmountRef]=useStateRef('');
   const [NoOfIns,setNoOfIns,NoOfInsRef]=useStateRef('');
   const [InsAmount,setInsAmount,InsAmountRef]=useStateRef('');
   const [RecedIns,setRecedIns,RecedInsRef]=useStateRef('');
   const [RecedAmount,setRecedAmount,RecedAmountRef]=useStateRef('');
   const [RecedWt,setRecedWt,RecedWtRef]=useStateRef('');
   const [CashAmount,setCashAmount,CashAmountRef]=useStateRef('');
   const [InstallmentAmount,setInstallmentAmount,InstallmentAmountRef]=useStateRef('');
  
   const [isHidden,setisHidden,isHiddenRef]=useStateRef(false);
  


   
//sales Detail
const [RecNo1,setRecNo1,RecNo1Ref]=useStateRef('');
const [InsNo,setInsNo,InsNoRef]=useStateRef(0);
const [Rate,setRate,RateRef]=useStateRef(0);
const [RecAmt,setRecAmt,RecAmtRef]=useStateRef(0);
const [RecWt,setRecWt,RecWtRef]=useStateRef(0);

//Card Details   
   const [CardId,setCardId,CardIdRef]=useStateRef('');
   const [CardName,setCardName,CardNameRef]=useStateRef('');
   const [CardBankName,setCardBankName,CardBankNameRef]=useStateRef('');
   const [CardNumber,setCardNumber,CardNumberRef]=useStateRef('');
   const [CardAmount,setCardAmount,CardAmountRef]=useStateRef('');
   const [CardDate,setCardDate,CardDateRef]=useStateRef((new Date()).toISOString().substring(0,10));
   const [CardComP,setCardComP,CardComPRef]=useStateRef('');
   const [CardComAmount,setCardComAmount,CardComAmountRef]=useStateRef('');

function getEmpName(id)
{
if(id==1)
{
  var result = dtEmpRef.current.find(obj => {
    return obj.OprCode === EmpId1Ref.current
  });
if(result!=undefined)
  setEmpName1(result.OprName);
else
  setEmpName1(""); 
}


}



   async function ChequeClear()
   {
		CheuqehandleClose1();
   }



    function CardAddGrid()
   {

    if((CardNameRef.current.length>0) || (CardBankNameRef.current.length>0))
    {
      setCardId(0);
      setCardName('');
      setCardBankName('');
      setCardAmount('');
      setCardComP('');
      setCardComAmount('');
      setCardNumber('');
    }
    else
    {
    
      CardhandleClose1();
    }
     
    CardDetTable=DtCardDetTable;
    var cnt = 0;
    try {
        cnt = CardDetTable.length;
    }
    catch (err) {
        cnt = 0;
    }
    let i=0;
    let PurAmount=0;
    for (i = 0; i < cnt; i++) {
      PurAmount=val(PurAmount)+val(CardDetTable[i].CardAmount);
    }

   setCardAmount(PurAmount);
   setRecAmount(CardAmountRef.current);

     }

   async function ChequeOpen()
   {
    ChequehandleShow1();
   }
   async function ChequeOK()
   {
    
   
    if((ChqBankNameRef.current.length>0) && (val(ChqAmountRef.current)>0) && (ChqNoRef.current.length>0))
     {
   
      setRecAmount(val(ChqAmountRef.current));
      setChequeshow1(false);
    } 
    else
    {
      setRecAmount('');  
  swal({
    title: "",
    text: "Fill All Data",
    icon: "info",
    button: "Ok"
  
  });
    }
   }
   
   async function UPIOK()
   {
    
    if((UPIIdRef.current.length>0) && (val(UPIAmountRef.current)>0) && (UPIRefNoRef.current.length>0))
     {
      setRecAmount(UPIAmountRef.current);
      UPIhandleClose1();
    } 
    else
    {
      setRecAmount('');  
  swal({
    title: "",
    text: "Fill All Data",
    icon: "info",
    button: "Ok"
  
  });
    }
   }
   

    async function CashOK()
   {
    
    if((val(CashAmountRef.current)>0))
     {
   setRecAmount(CashAmountRef.current);
      CashhandleClose1();
    } 
    else
    {
      setRecAmount('');  
  swal({
    title: "",
    text: "Fill All Data",
    icon: "info",
    button: "Ok"
  
  });
    }
   }
   

   async function ChequeClose()
   {
    if(ChqBankNameRef.current.length>0)
    {
    setChqBankName('');
    setChqAmount('');
    setChqNo('');
    setChqDate((new Date()).toISOString().substring(0,10));

    }
    else
    {
    CheuqehandleClose1();
    }

   }


   async function UPIClose()
   {
    if(ChqBankNameRef.current.length>0)
    {
    setUPIId('');
    setUPIAmount('');
    setUPIRefNo('');
  
    }
    else
    {
    UPIhandleClose1();
    }

   }

  async function CashClose()
   {
    if(ChqBankNameRef.current.length>0)
    {
   setCashAmount('');
  
    }
    else
    {
    CashhandleClose1();
    }

   }


   async function CardOpen()
   {
    CardhandleShow1();
   }



function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



async function Calc()
{
  
 

}


async function ControlSettings()
{

  document.getElementById("txtBillNo").disabled ='true';
  
  
  if((sessionStorage.getItem("SchemeRec_Action")=="Edit") || (sessionStorage.getItem("SchemeRec_Action")=="Delete"))
   {
  
    
    

   }

 



}



async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    
  setisHidden(true);

    const results = await apiService.postCall("schemerec/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let DetailData=results.data.PurDetail;
   let CardData=results.data.SalesCard;
   
   if(CardData[0].length>0)
   setDtCardDetTable(CardData[0]);

  
  if(DetailData[0].length>0)
   setDtDetTable(DetailData[0]);


       setRecNo(HeadData[0][0].RecNo);
       setRecDate(HeadData[0][0].RecDate1);
       setSchCode(HeadData[0][0].SchCode);
       setSchName(HeadData[0][0].SchemeName);
       setSchType(HeadData[0][0].SchType);
       setChitCode(HeadData[0][0].ChitCode);
       setCustId(HeadData[0][0].CustId);
       setNoOfIns(HeadData[0][0].NoOfIns);
       setInsAmount(HeadData[0][0].InsAmount);
       setRecMode(HeadData[0][0].RecMode);
       setRecIns(HeadData[0][0].RecIns);
       setRecAmount(HeadData[0][0].RecAmount);
       setEmpId1(HeadData[0][0].EmpId);
       setEmpName1(HeadData[0][0].OprName);
       setChqBankName(HeadData[0][0].BankName);
       setChqNo(HeadData[0][0].ChequeNo);
       setChqDate(HeadData[0][0].ChequeDate1);
       setChqAmount(HeadData[0][0].CheqAmount);
       setUPIId(HeadData[0][0].UPIId);
       setUPIRefNo(HeadData[0][0].UPIRefNo);
       setUPIAmount(HeadData[0][0].UPIAmount);
       setCashAmount(HeadData[0][0].CashAmount);
       setCardAmount(HeadData[0][0].CardAmount);
       setInstallmentAmount(HeadData[0][0].TInsAmount);
     

  await getLookup();
  await getChitDetail();
   
       
   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
		
		let postData = {
			"Action" : sessionStorage.getItem("SchemeRec_Action"),
			"EditId" : sessionStorage.getItem("SchemeRec_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
      "RecNo":RecNoRef.current,
      "RecDate":RecDateRef.current,
      "SchCode":SchCodeRef.current,
      "SchType":SchTypeRef.current,
      "ChitCode":ChitCodeRef.current,
      "CustId":CustIdRef.current,
      "NoOfIns":NoOfInsRef.current,
      "InsAmount":InsAmountRef.current,
      "RecMode":RecModeRef.current,
      "RecIns":RecInsRef.current,
      "RecAmount":RecAmountRef.current,
      "EmpId":EmpId1Ref.current,
      "ChqBankName":ChqBankNameRef.current,
      "ChqNo":ChqNoRef.current,
      "ChqDate":ChqDateRef.current,
      "CardAmount":CardAmountRef.current,
      "CashAmount":CashAmountRef.current,
      "ChqAmount":ChqAmountRef.current,
      "UPIAmount":UPIAmountRef.current,
      "InstallmentAmount":InstallmentAmountRef.current,
      "UPIId":UPIIdRef.current,
      "UPIRefNo":UPIRefNoRef.current,
      "UPIAmount":UPIAmountRef.current,
      "DtSaleDetTable":DtDetTableRef.current,
      "DtCardDetTable":DtCardDetTableRef.current
		}

    let ErrMsg="";

    if((EmpName1Ref.current==undefined)||(EmpName1Ref.current==''))
      {
        ErrMsg="Invalid Employee Code";
      }

    if((postData.EmpId==undefined)||(postData.EmpId==''))
      {
        ErrMsg="Please Enter Employee Code";
      }
  
      if((postData.RecAmount==undefined)||(val(postData.RecAmount)==0))
        {
          ErrMsg="Please Enter Receipt Value";
        }

        if((postData.RecIns==undefined)||(val(postData.RecIns)==0))
          {
            ErrMsg="Please Enter Installment";
          }

      if((postData.RecMode==undefined)||(postData.RecMode==''))
        {
          ErrMsg="Please Select Receipt Mode";
        }

      if((postData.ChitCode==undefined)||(postData.ChitCode==''))
        {
          ErrMsg="Please Select Chit No";
        }
      if((postData.SchCode==undefined)||(postData.SchCode==''))
        {
          ErrMsg="Please Select Scheme Name";
        }
    

        if(val(postData.RecAmount)!=val(postData.InstallmentAmount))
          {
            ErrMsg="Received Amount and Installment Amount does not match";
          }
  
    if(ErrMsg=="")
    {
    

      const results1 = await apiService.postCall("schemerec/ValidationChk",postData);

   if (results1 != "-1") {

if(results1.errorCode=="8888")
{
    
  
  swal({

    title: "",
    text: results1.data,
    icon: "error",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  

   }

   const results = await apiService.postCall("schemerec/Save",postData);

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "",
    text: results.data,
    icon: "error",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("SchemeRec_Action")=="Add")
   {

  let backtonew=false;

    if(sessionStorage.getItem("NewScheme_SchCode")!="")
  {
    sessionStorage.setItem("NewScheme_SchCode","");
    sessionStorage.setItem("NewScheme_ChitCode","");
    backtonew=true;
  }   

    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      if(backtonew==false)
      BackToList();
      else
      BackToNewList();
    });
	
  }

  else if(sessionStorage.getItem("SchemeRec_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("SchemeRec_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }

    }
    else
    {
      swal({

        title: "",
        text: ErrMsg,
        icon: "error",
        button: "Ok"
   
      }).then(function () {
        
      });
    }
    }
    catch (error) {
      console.log(error);
    }

  }



    
function CardCalc()
{
let CardAmount=val(CardAmountRef.current);
let CardComP=val(CardComPRef.current);

let CardComAmount=0;
CardComAmount=val(val(CardAmount)*val(CardComP)/100).toFixed(2);
setCardComAmount(CardComAmount);
}
  


  async function CardgridEdit (id) {

        CardDetTable=DtCardDetTable;

    var cnt = 0;
    try {
        cnt = CardDetTable.length;
    }
    catch (err) {
        cnt = 0;
    }





    let i=0;

    for (i = 0; i < cnt; i++) {
        if (CardDetTable[i].ID == id) {

            setCardId(id);
            setCardName(CardDetTable[i].CardName);
            setCardBankName(CardDetTable[i].CardBankName);
            setCardDate(CardDetTable[i].CardDate);
            setCardNumber(CardDetTable[i].CardNumber);
            setCardAmount(CardDetTable[i].CardAmount);
            setCardComP(CardDetTable[i].CardComP);
            setCardComAmount(CardDetTable[i].CardComAmount);
            
   
            break;

        }          
    }

    setDtCardDetTable(CardDetTable);
  


}


  function CardgridRemove (id) {



    CardDetTable=DtCardDetTable;
     
      var cnt = 0;
      try {
          cnt = CardDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }
   
    let i=0;

      for (i = 0; i < cnt; i++)
      {
          if ((CardDetTable[i].ID == id))
          {
            CardDetTable.splice(i, 1);
              break;
          }
      }

      setDtCardDetTable(CardDetTable);
    
    setCardName("");
    
    
    
    //Clear();

  }



  async function CardClear()
  {

     setCardId(0);
     setCardName('');
     setCardBankName('');
     setCardAmount('');
     setCardComP('');
     setCardComAmount('');
      setCardNumber('');

                      

  }
   

  async function CardCancel()
  {

    if((CardNameRef.current.length>0) || (CardBankNameRef.current.length>0))
    {
      setCardId(0);
      setCardName('');
      setCardBankName('');
      setCardAmount('');
      setCardComP('');
      setCardComAmount('');
       setCardNumber('');
    }
    else
    {
      CardhandleClose1();
    }
     
                      
      
  }

   


async function CardgridAdd () {


  let slno=CardIdRef.current;
  let CardName=CardNameRef.current;
  let CardBankName=CardBankNameRef.current;
  let CardNumber=CardNumberRef.current;
  let CardDate=CardDateRef.current;
  let CardAmount=val(CardAmountRef.current);
  let CardComP=val(CardComPRef.current);
  let CardComAmount=val(CardComAmountRef.current);
  

if ((CardBankName.length>0)&&(CardName.length>0)&&(CardAmount>0)&&(CardName.length>0))
{
  CardDetTable=DtCardDetTable;


    var cnt = 0;
    try
    {
        cnt = CardDetTable.length;
       
    }
    catch(err)
    {
        cnt=0;
    }



    var found = false;
    var i=0;

    for (i = 0; i < cnt; i++) {



        if ((CardDetTable[i].ID == slno)) {


          CardDetTable[i].CardName=CardName;
          CardDetTable[i].CardBankName=CardBankName;
          CardDetTable[i].CardNumber=CardNumber;
          CardDetTable[i].CardAmount=CardAmount;
          CardDetTable[i].CardComP=CardComP;
          CardDetTable[i].CardComAmount=CardComAmount;
          CardDetTable[i].CardDate=CardDate;
           
           
            //det text box clear

          await CardClear();


            found = true;
            break;
        }
        else {


            if ((CardDetTable[i].CardName == CardName) && (CardDetTable[i].CardBankName == CardBankName) && (CardDetTable[i].CardNumber == CardNumber) && (parseFloat(CardDetTable[i].CardAmount).toFixed(3) == parseFloat(CardAmount).toFixed(3))) {
                swal({
        title: "",
        text: "Already Found",
        icon: "info",
        button: "Ok"

        });

                found = true;
                break;

            }
        }
    }


    if (found == false) {

        var row = {
            "ID": parseInt(cnt) + 1
            , "CardName":CardName
            , "CardBankName":CardBankName
            , "CardNumber":CardNumber
            , "CardDate":CardDate
            , "CardAmount":CardAmount
            , "CardComP":CardComP
            , "CardComAmount":CardComAmount
        };

            CardDetTable[cnt] = row;

         await CardClear();
        

         //Calc();

              

    }
  
  await setDtCardDetTable(CardDetTable);





  //alert(JSON.stringify(DtDetTable));

 CardCalc();


}
else
{

swal({
  title: "",
  text: "Fill All Data",
  icon: "info",
  button: "Ok"

});


//alert("Fill All Data");
}

}



  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : 0
    };
		
    const results = await apiService.postCall("schemerec/Lookup",postData);

	 if (results != "-1") {

    setdtScheme(results.data[0][0]);
    setdtEmp(results.data[1][0]);
    setdtCard(results.data[2][0]);
    setdtChqBank(results.data[3][0]);
    setdtRecMode(results.data[4][0]);
    
    
      }

    } catch (error) {
      console.log(error);
    }
}

async function getChitList(){
  try {		
        
   let postData = {
     "SchCode" : SchCodeRef.current,
     "eBranchCode" : sessionStorage.getItem("BranchCode")
   };
   
   const results = await apiService.postCall("schemerec/getChitList",postData);

  if (results != "-1") {

   setdtChitList(results.data[0][0]);
  
   
     }

   } catch (error) {
     console.log(error);
   }
}


async function GetInsDetail(){
  try {		
        
   let postData = {
     "ChitCode" : ChitCodeRef.current,
     "RecIns" : RecInsRef.current,
     "RecDate" : RecDateRef.current,
     "InsAmount": InsAmountRef.current,
     "RecNo": RecNoRef.current,
     "Action":sessionStorage.getItem("SchemeRec_Action")
   };
   
  
   const results = await apiService.postCall("schemerec/getInsDetail",postData);

   if(results.Error.length>0)
    {
      swal({
        title: "",
        text: results.Error,
        icon: "error",
        button: "Ok"
      
      });
      results="-1";

    }

    setInstallmentAmount(0);


  if (results != "-1") {
    setDtDetTable([]);
    setDtDetTable(results.data[0][0]);

    let Dt1=DtDetTableRef.current;
    var cnt = 0;
    try
    {
        cnt = Dt1.length;
       
    }
    catch(err)
    {
        cnt=0;
    }

    var i=0;

let TAmt=0;
    for (i = 0; i < cnt; i++) {
TAmt=TAmt+val(Dt1[0].RecAmt);
    }

    setInstallmentAmount(TAmt);


  
     }

   } catch (error) {
     console.log(error);
   }
}

async function RecModeChange(){
  
  setRecAmount('');

if(RecModeRef.current=="CHEQUE" || RecModeRef.current=="MO" || RecModeRef.current=="DD")
{

  setUPIAmount('');
  setCashAmount('');
  setUPIRefNo('');
  setUPIId('');
  setCardAmount('');
  setDtCardDetTable([]);


  setChequeshow1(true);
}
else if(RecModeRef.current=="UPI") 
  {
    setDtCardDetTable([]);
   
    setChqAmount('');
    setChqBankName('');
    setChqDate((new Date()).toISOString().substring(0,10));
    setChqNo('');
    setCashAmount('');
    setCardAmount('');

    setUPIhow1(true);
  }
  else if(RecModeRef.current=="CARD") 
    {

      setChqAmount('');
      setChqBankName('');
      setChqDate((new Date()).toISOString().substring(0,10));
      setChqNo('');
      setCashAmount('');

      setUPIAmount('');
      setUPIRefNo('');
      setUPIId('');

      
      setCardshow1(true);
    }

     else if(RecModeRef.current=="CASH") 
    {

      setChqAmount('');
      setChqBankName('');
      setChqDate((new Date()).toISOString().substring(0,10));
      setChqNo('');
      
      setUPIAmount('');
      setUPIRefNo('');
      setUPIId('');

      setCardAmount('');
      setDtCardDetTable([]);
      
      setCashshow1(true);
    }
}

async function getChitDetail(){
  try {		
        
   let postData = {
     "ChitCode" : ChitCodeRef.current,
    
   };
   
   const results = await apiService.postCall("schemerec/getChitDetail",postData);

  if (results != "-1") {

   setdtChitDet(results.data[0][0]);
   setdtChitPaidDet(results.data[1][0]);
  
   

   if(dtChitDetRef.current.length>0)
      {
        setCustId(dtChitDetRef.current[0].CustId);
        setCustName(dtChitDetRef.current[0].CustName);
        setAddress1(dtChitDetRef.current[0].Address);
        setMobile(dtChitDetRef.current[0].MobileNo);
        setEmailId(dtChitDetRef.current[0].EmailId);
        setNoOfIns(dtChitDetRef.current[0].NoOfIns);
        setInsAmount(dtChitDetRef.current[0].InsAmount);
        setSchType(dtChitDetRef.current[0].SchType);
      }

    
      if(dtChitPaidDetRef.current.length>0)
        {
          setRecedIns(dtChitPaidDetRef.current[0].RecIns);
          setRecedAmount(dtChitPaidDetRef.current[0].RecAmount);
          setRecedWt(dtChitPaidDetRef.current[0].RecWt);
        }

        if(sessionStorage.getItem("SchemeRec_Action")=="Add")
          {
        await GetInsDetail();
          }
     }

   } catch (error) {
     console.log(error);
   }
}

  const navigate = useNavigate();
  const BackToList = () => {
  navigate('../dashboard/table/chit/schemerec/list');
  };
   
  const BackToNewList = () => {
    navigate('../dashboard/table/chit/newscheme/list');
    };
  
  return (
    <>  
    

      <Row >
        <Card>
          <Card.Header className="d-flex ">
            <div className="header-title">
             </div>
          </Card.Header>
          <Card.Body className='BillScreen'> 
            <div className='container billcontainer'>
              <div className='container-fluid'>

             

                <div className='row'>
                  <div className='col-lg-4'>
                       
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Rec No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtBillNo" placeholder="" value={RecNo}  />
                          </div>
                         
                          <div className='col-md-6'>
                            <Form.Label>Rec Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtBillDate" placeholder="" value={RecDate} onChange={(e)=>setRecDate(e.target.value)} />
                          </div>
						  
                          <div className='col-md-12'>
                              <Form.Label>Scheme</Form.Label>
                              <Form.Control hidden={!isHidden} type="text" className="txtReadOnly" Readonly="Readonly" placeholder="" value={SchName}  />
                    
                              { isHidden ? null : (   <Select className="form-select-search"  
                             options={dtScheme}
                             value={dtScheme.filter(function(option) {
                              return option.value === SchCode;
                            })}
                            onChange=
                            {   
                              (e) => {
                            setSchCode(e.value);
                            getChitList();
                              }
                              }
                             disabled='true'>
              				       </Select>)}

                        </div>
                          
                        <div className='col-md-6'>
                              <Form.Label>Chit Code</Form.Label>

                              <Form.Control hidden={!isHidden} type="text" className="txtReadOnly" Readonly="Readonly" placeholder="" value={ChitCode}  />
                    

                             { isHidden ? null : ( <Select className="form-select-search" 
                             options={dtChitList}
                             value={dtChitList.filter(function(option) {
                              return option.value === ChitCode;
                            })}
                            onChange=
                            {
                              (e) => {
                            setChitCode(e.value);
                            getChitDetail();
                            
                              }
                              }
                             disabled={false}>
              				       </Select>)}
                        </div>


                        <div className='col-md-6'>
                              <Form.Label>Rec Mode</Form.Label>
                              <Select className="form-select-search"  
                             options={dtRecMode}
                             value={dtRecMode.filter(function(option) {
                              return option.value === RecMode;
                            })}
                            onChange=
                            {
                              (e) => {
                            setRecMode(e.value);
                            RecModeChange();
                              }
                              }
                             disabled={false}>
              				       </Select>
                        </div>

                        <div className='col-md-6'>
                            <Form.Label>Installment</Form.Label>
                            <Form.Control type="text"   placeholder="" value={RecIns} onChange=
                               {
                                (e) => {
                                setRecIns(e.target.value);
                                GetInsDetail();
                                }
                                }
                              />
                          </div>

                          <div className='col-md-6'>
                            <Form.Label>Rec. Amount</Form.Label>
                            <Form.Control type="text" Readonly="ReadOnly"  className='txtReadOnly'  placeholder="" value={RecAmount}  />
                          </div>

                          <div className='col-md-6'>
                            <Form.Label>Ins. Amount</Form.Label>
                            <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly'  placeholder="" value={InstallmentAmount}  />
                          </div>


</div>
</div>
<div className='col-lg-8'>
<div className='row'>
<div className='col-md-8'>

                        <div className='col-md-12'>
                            <Form.Label>Customer Name</Form.Label>
                            <Form.Control type="text" className='txtReadOnly' Readonly="ReadOnly"  placeholder="" value={CustName}  />
                          </div>

                          <div className='col-md-12'>
                            <Form.Label>Address</Form.Label>
                            <textarea rows="4" className='form-control txtReadOnly' Readonly="ReadOnly"  placeholder="" value={Address1}  />
                                        </div>

                                        <div className='col-md-6'>
                            <Form.Label>No.Of Installment</Form.Label>
                            <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly'  placeholder="" value={NoOfIns}  />
                          </div>
                           <div className='col-md-6'>
                            <Form.Label>Installment Amount</Form.Label>
                            <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly' placeholder="" value={InsAmount}  />
                          </div>
                    
                        </div>

                        <div className='col-md-4'>
                            <div className='col-md-12'>
                            <Form.Label>Received Installment</Form.Label>
                            <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly'  placeholder="" value={RecedIns}  />
                          </div>

                           <div className='col-md-12'>
                            <Form.Label>Received Amount</Form.Label>
                            <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly'  placeholder="" value={RecedAmount}  />
                          </div>

                           <div className='col-md-12'>
                            <Form.Label>Received Weight</Form.Label>
                            <Form.Control type="text" Readonly="ReadOnly" className='txtReadOnly' placeholder="" value={RecedWt}  />
                          </div>
                        </div>
                       
                        </div>
</div>
                  </div>
                 
                  <div className='row'>
                  <div className='col-lg-12'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>

                       
   
    
    <div className="table-responsive mt-4" >
			 
   
       	   
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th>Rec No</th>
             <th>Ins.No</th>
             <th>Ins.Amount</th>                 
             <th>Rate</th>
             <th>Weight</th>
             
           </tr>
         </thead>
         <tbody>
         {DtDetTable.map((item) => (
           <tr>
             

             <td>{item.RecNo1}</td>
             <td>{item.InsNo}</td>
             <td>{item.RecAmt}</td>
             <td>{item.Rate}</td>                 
             <td>{item.RecWt}</td>
           

           </tr>
   )
   )
    }     
         </tbody>
       </Table>



                         
                         
     </div>
     


    
      <div className='row'>

      <div className='col-lg-2'>
      <div className='col-md-12'>
  <Form.Label>Emp Id</Form.Label>
  <Form.Control type="text" value={EmpId1} onChange=
                            {
                              (e) => {
                            setEmpId1(e.target.value);
                            getEmpName(1);
                              }
                              } placeholder=""   />
</div>



</div>

<div className='col-lg-4'>
      <div className='col-md-12'>
  <Form.Label>Emp Name</Form.Label>
  <Form.Control type="text"  placeholder="" value={EmpName1}  className="txtReadOnly" Readonly="ReadOnly"  />
</div>



</div>
        </div>
    

                          </div>
                      </div>
                    </div>
                  </div>
              </div>
              </div>
              <Modal show={UPIShow1}  className=".modal-xl"  >
                  <Modal.Header >
                    <Modal.Title>UPI Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                        <div className='col-md-12'>
                              <Form.Label>UPI Id</Form.Label>
                              <Form.Control type="text"   value={UPIId} onChange=
                            {
                              (e) => {
                            setUPIId(e.target.value);
                              }
                              }  placeholder="" />
                        </div>
                        <div className='col-md-12'>
                              <Form.Label>UPI Ref.No</Form.Label>
                              <Form.Control type="text"   value={UPIRefNo} onChange=
                            {
                              (e) => {
                            setUPIRefNo(e.target.value);
                              }
                              }  placeholder="" />
                        </div>


                         
                            <div className='col-md-12'>
                              <Form.Label>Amount</Form.Label>
                              <Form.Control type="number" value={UPIAmount} onChange=
                            {
                              (e) => {
                            setUPIAmount(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                                 


</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick={UPIOK}>OK</Button>
					<Button type="button" className="detbutton"  variant="btn btn-primary" onClick={UPIClose}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
                <Modal show={CashShow1}  className=".modal-xl"  >
                  <Modal.Header >
                    <Modal.Title>Cash Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                      
                  

                         
                            <div className='col-md-12'>
                              <Form.Label>Cash Amount</Form.Label>
                              <Form.Control type="number" value={CashAmount} onChange=
                            {
                              (e) => {
                            setCashAmount(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                                 


</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick={CashOK}>OK</Button>
					<Button type="button" className="detbutton"  variant="btn btn-primary" onClick={CashClose}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
      
                <Modal show={Chequeshow1}  className=".modal-xl"  >
                  <Modal.Header >
                    <Modal.Title>Cheque/DD/MO Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                        <div className='col-md-12'>
                              <Form.Label>Bank Name</Form.Label>
                              <Select className="form-select-search" 
                             options={dtChqBank}
                             value={dtChqBank.filter(function(option) {
                              return option.value === ChqBankName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setChqBankName(e.value);
                            setChqAmount('');

                              }
                              }
                             disabled={false}>
              				       </Select>
                     
                            </div>

                        <div className='col-md-12'>
                              <Form.Label>Cheque No/DD No/MO No</Form.Label>
                              <Form.Control type="text"   value={ChqNo} onChange=
                            {
                              (e) => {
                            setChqNo(e.target.value);
                              }
                              }  placeholder="" />
                        </div>


                            <div className='col-md-12'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date"  value={ChqDate} onChange=
                            {
                              (e) => {
                            setChqDate(e.target.value);
                              }
                              } placeholder=""  />
                          </div>

                            <div className='col-md-12'>
                              <Form.Label>Amount</Form.Label>
                              <Form.Control type="number" value={ChqAmount} onChange=
                            {
                              (e) => {
                            setChqAmount(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                                 


</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick={ChequeOK}>OK</Button>
					<Button type="button" className="detbutton"  variant="btn btn-primary" onClick={ChequeClose}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				
                <Modal show={Cardshow1} className=" .modal-xl" id="EntryModal1" >
                  <Modal.Header >
                    <Modal.Title>Card Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                      <div className='col-md-2'>
                              <Form.Label>Card Type</Form.Label>
                     
                              <Select className="form-select-search"  
                             options={dtCard}
                             value={dtCard.filter(function(option) {
                              return option.value === CardName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setCardName(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>
                                           </div>
                    
                      <div className='col-md-5'>
                              <Form.Label>Bank</Form.Label>
                              <Select className="form-select-search"  
                             options={dtChqBank}
                             value={dtChqBank.filter(function(option) {
                              return option.value === CardBankName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setCardBankName(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>
                        </div>
                      <div className='col-md-2'>
                              <Form.Label>Amount</Form.Label>
                              <Form.Control type="number"  value={CardAmount}  onChange=
                            {
                              (e) => {
                            setCardAmount(e.target.value);
                            CardCalc();
                              }
                              }  placeholder="" />
                      </div>

                      <div className='col-md-3'>
                              <Form.Label>Com.%</Form.Label>
                              <div className='row'>
    <div className='col-md-4'> <Form.Control  type="number"  value={CardComP}  onChange=
                            {
                              (e) => {
                            setCardComP(e.target.value);
                            CardCalc();
                              }
                              } placeholder=""    /> 
 </div>
 <div className ='col-md-8'> <Form.Control className='col-md-10 txtReadOnly' type="number" Readonly="Readonly" value={CardComAmount} onChange=
                            {
                              (e) => {
                            setCardComAmount(e.target.value);
                            CardCalc();
                              }
                              }  placeholder=""   />
 </div>
</div>
                      </div>

                      <div className='col-md-8'>
                              <Form.Label>Card No</Form.Label>
                              <Form.Control type="text"  value={CardNumber}  onChange=
                            {
                              (e) => {
                            setCardNumber(e.target.value);
                              }
                              }  placeholder="" />
                      </div>
                  
                      <div className='col-md-4'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date"  placeholder="" value={CardDate} onChange={(e)=>setCardDate(e.target.value)} />
                          </div>

                            

                            <div style={{ "text-align": 'center' }}>
                    <Button type="button" className="detbutton"   variant="btn btn-primary" onClick={CardgridAdd}>Add to Table</Button>
					              </div>


                       <div className="table-responsive mt-4" >
			 
				
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Edit</th>
           <th>Card Name</th>
             <th>Bank Name</th>
             <th>Card No</th>
             <th>Amount</th>   
             <th>Com.%</th>   
             <th>Com.Amt</th>   

            <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtCardDetTable.map((item) => (
           <tr >
              <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>CardgridEdit(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             <td>{item.CardName}</td>
             <td>{item.CardBankName}</td>
             <td>{item.CardNumber}</td>
             <td>{item.CardAmount}</td>
             <td>{item.CardComP}</td>
             <td>{item.CardComAmount}</td>
           
           
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>CardgridRemove(item.ID)}>
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
            
            )
            )
             }     
         </tbody>
       </Table>
<div className="EntryPan">

<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#" onClick={CardClear}>
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>



</div>
     </div>

     <div style={{ "direction": 'rtl' }}>
  
                    <Button type="button" className="detbutton"   variant="btn btn-primary" onClick={CardAddGrid}>OK</Button>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick=
                    {e=>{
                      CardCancel();
                      }}>Cancel</Button>
  </div>

</div>
</div>

                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>

            


             
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
